import { when } from '@execonline-inc/maybe-adapter';
import { Maybe, just } from 'maybeasy';
import { ProductLicenseResource } from '../../Types';
import LearningCollectionStore from '../Store';

export const whenNoMatchingProductIds = (
  selectedProductLicense: Maybe<ProductLicenseResource>,
  initialProductLicense: Maybe<ProductLicenseResource>,
) =>
  just({})
    .assign('selectedProductLicense', selectedProductLicense)
    .assign('initialProductLicense', initialProductLicense)
    .andThen(({ selectedProductLicense, initialProductLicense }) =>
      when(selectedProductLicense.payload.id !== initialProductLicense.payload.id, true),
    );

const reloadLearningDesigns = (
  store: LearningCollectionStore,
  selectedProductLicense: Maybe<ProductLicenseResource>,
  initialProductLicense: Maybe<ProductLicenseResource>,
) =>
  when(initialProductLicense.isNothing(), true)
    .orElse(() => whenNoMatchingProductIds(selectedProductLicense, initialProductLicense))
    .do(() => store.learningDesignsStore.loading(selectedProductLicense));

export default reloadLearningDesigns;
